import { Directive, effect, inject, input, TemplateRef, ViewContainerRef } from '@angular/core';
import { CURRENT_USER_ROLE } from '@dss-libs/shared/utility/global-injection-tokens';
import { isUserAuthorized } from '@dss-libs/shared/utility/common-utilities';
import { UserRole } from '@dss-libs/shared/type/common-types';

@Directive({
  selector: '[dssLibsUiAuthorizedRole]',
})
export class AuthorizedRoleDirective {
  private readonly templateRef = inject(TemplateRef);
  private readonly viewContainerRef = inject(ViewContainerRef);
  private readonly currentUserRole = inject(CURRENT_USER_ROLE);

  readonly dssLibsUiAuthorizedRole = input<UserRole | undefined>();

  constructor() {
    effect(() => {
      const requiredRole = this.dssLibsUiAuthorizedRole();
      this.viewContainerRef.clear();
      if (!requiredRole || isUserAuthorized(this.currentUserRole(), requiredRole)) {
        this.viewContainerRef.createEmbeddedView(this.templateRef);
      }
    });
  }
}
